import ProgressRing from './ProgressRing';
import ProgressItemRing from './ItemRing';
import progressRingStyles from './progressRing.module.scss';

export { ProgressRing, ProgressItemRing, progressRingStyles };

export default ProgressRing;
